import Vue from 'vue';
import Component from 'vue-class-component';
import Lottie from 'vue-lottie';

import * as check from 'assets/lotties/check_02.json';

@Component({
  props: {
    startStep: {
      type: Object,
    },
  },
  components: {
    Lottie
  }
})
export default class FinalStepComponent extends Vue {
  lotties = {
    animationData: check.default,
  }
}
